import { Authenticator } from '@aws-amplify/ui-react';
import { PropsWithChildren } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import UserAuthenticationContextProvider from '@/features/userAuth/context/UserAuthenticationContext';
import SubscriptionDebuggerContextProvider from '@/services/subscriptions/SubscriptionDebuggerContext';
import { SubscriptionManagerProvider } from '@/services/subscriptions/SubscriptionManagerContext';
import { theme } from '@/theme/theme';
import { StandaloneModalProvider } from '@/ui/StandaloneModal/StandaloneModalProvider';
import { PubSubProvider } from '@/utils/helpers/hooks/PubSubProvider';

export const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <Authenticator.Provider>
      <ChakraProvider theme={theme}>
        <StandaloneModalProvider>
          <SubscriptionManagerProvider>
            <SubscriptionDebuggerContextProvider>
              <UserAuthenticationContextProvider>
                <PubSubProvider>{children}</PubSubProvider>
              </UserAuthenticationContextProvider>
            </SubscriptionDebuggerContextProvider>
          </SubscriptionManagerProvider>
        </StandaloneModalProvider>
      </ChakraProvider>
    </Authenticator.Provider>
  );
};
